"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingRateSchemaProperties = exports.BillingRateSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const BillingRateStatus = zod_1.z.enum(["active", "inactive"]);
const BillingRateType = zod_1.z.enum(["session", "billable"]);
exports.BillingRateSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    value: zod_1.z.number(),
    icon: zod_1.z.string().optional(),
    status: BillingRateStatus,
    type: BillingRateType,
    overwriting: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({ value: zod_1.z.number().optional() }))
        .optional(),
});
exports.BillingRateSchemaProperties = {
    collectionName: "billingRates",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=billing-rate-schema.js.map